import { synthesizeSpeech } from "@/services/voice/client";

/**
 * Voice Engine — real playback via HTMLAudioElement, backed by the
 * server-side Voxtral proxy. Reports progress fractions so the
 * Timeline Engine can schedule whiteboard writes to START partway
 * through speech (overlap, not sequence — plan §7), and exposes
 * pause/resume/interrupt/speed for the transport controls.
 */
export class VoiceEngine {
  private audio: HTMLAudioElement | null = null;
  private objectUrl: string | null = null;

  async speak(
    text: string,
    opts: { speed?: number; onProgress?: (fraction: number) => void; onEnded?: () => void } = {}
  ) {
    this.cleanup();
    const url = await synthesizeSpeech(text);
    this.objectUrl = url;

    const audio = new Audio(url);
    audio.playbackRate = opts.speed ?? 1;
    this.audio = audio;

    audio.addEventListener("timeupdate", () => {
      if (audio.duration > 0) opts.onProgress?.(audio.currentTime / audio.duration);
    });
    audio.addEventListener("ended", () => {
      opts.onEnded?.();
      this.cleanup();
    });

    await audio.play();
  }

  pause() {
    this.audio?.pause();
  }

  resume() {
    this.audio?.play();
  }

  interrupt() {
    this.cleanup();
  }

  setSpeed(speed: number) {
    if (this.audio) this.audio.playbackRate = speed;
  }

  private cleanup() {
    this.audio?.pause();
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
    this.audio = null;
    this.objectUrl = null;
  }
}
